export const FF_DASHBOARD_NEW_ALLOW_VA_CREATION_FOR_INDIVIDUALS =
  'dashboard-new-allow-va-creation-for-individuals';
export const FF_DASHBOARD_NEW_MXNB_BALANCES = 'dashboard-new-mxnb-balances';
export const FF_DASHBOARD_NEW_BRL1_BALANCES = 'dashboard-new-brl-1-balances';
export const FF_DASHBOARD_NEW_INTERNAL_TRANSFERS = 'dashboard-new-internal-transfers';
export const FF_DASHBOARD_NEW_CNY_HKD_CURRENCIES = 'dashboard-new-cny-hkd-currencies';
export const FF_DASHBOARD_NEW_EUR_SEPA = 'dashboard-new-eur-sepa';
